import { z } from 'zod';

import { AvatarBlockSchema } from './Avatar';
import { ButtonBlockSchema } from './Button';
import { ColumnsSectionBlockSchema, type TColumnsSectionBlock } from './ColumnsSection';
import { ContainerBlockSchema, type TContainerBlock } from './Container';
import { ContainerYieldBlockSchema } from './ContainerYield';
import { DividerBlockSchema } from './Divider';
import { HeadingBlockSchema } from './Heading';
import { HtmlBlockSchema } from './Html';
import { ImageBlockSchema } from './Image';
import { LoopContainerBlockSchema, type TLoopContainerBlock } from './LoopContainer';
import { ProgressBarBlockSchema } from './ProgressBar';
import { SpacerBlockSchema } from './Spacer';
import { TextBlockSchema } from './Text';

type TBaseColumnsSectionBlockProps = NonNullable<TColumnsSectionBlock['props']>;
export type TColumnsSectionBlockProps = {
  dimensionsRule: NonNullable<TBaseColumnsSectionBlockProps['dimensionsRule']>;
  fixedWidths: NonNullable<TBaseColumnsSectionBlockProps['fixedWidths']>;
  columnGridDimensions: NonNullable<TBaseColumnsSectionBlockProps['columnGridDimensions']>;
  contentAlignment: NonNullable<TBaseColumnsSectionBlockProps['contentAlignment']>;
  columnsCount: NonNullable<TBaseColumnsSectionBlockProps['columnsCount']>;
  columnGap: NonNullable<TBaseColumnsSectionBlockProps['columnGap']>;
  mobileLayout: NonNullable<TBaseColumnsSectionBlockProps['mobileLayout']>;
  blocks: NonNullable<TBaseColumnsSectionBlockProps['blocks']>;
};

export const BlockSchema = z.discriminatedUnion('type', [
  AvatarBlockSchema,
  ButtonBlockSchema,
  ColumnsSectionBlockSchema,
  ContainerBlockSchema,
  ContainerYieldBlockSchema,
  DividerBlockSchema,
  HeadingBlockSchema,
  HtmlBlockSchema,
  ImageBlockSchema,
  LoopContainerBlockSchema,
  ProgressBarBlockSchema,
  SpacerBlockSchema,
  TextBlockSchema,
]);

export type TBlock = z.infer<typeof BlockSchema>;

export function isContainerBlock(block: TBlock): block is TContainerBlock | TLoopContainerBlock | TColumnsSectionBlock {
  switch (block.type) {
    case 'ColumnsSection':
    case 'Container':
    case 'LoopContainer':
      return true;
    default:
      return false;
  }
}
